import React, { useState, useEffect, useRef } from 'react'

const AnimatedTypeComponent = ({ types }) => {
	const [currentIndex, setCurrentIndex] = useState(0)
	const nextIndex = (currentIndex + 1) % types.length
	const [animationState, setAnimationState] = useState('entering') // "entering", "visible", "exiting"
	const containerRef = useRef(null)

	const [isLoaded, setIsLoaded] = useState(false)
	useEffect(() => {
		setIsLoaded(true)
	}, [])

	useEffect(() => {
		const cycleTypes = () => {
			if (animationState === 'entering') {
				setAnimationState('visible')
				setTimeout(() => setAnimationState('exiting'), 50)
			} else if (animationState === 'exiting') {
				setCurrentIndex(nextIndex)
				setAnimationState('entering')
			}
		}

		const animationTimer = setTimeout(cycleTypes, animationState === 'visible' ? 0 : 3000)
		return () => clearTimeout(animationTimer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [animationState, currentIndex, types.length])

	useEffect(() => {
		if (containerRef.current) {
			const currentTypeElement = containerRef.current.querySelector(`[data-index="${currentIndex}"]`)
			if (currentTypeElement) {
				containerRef.current.style.width = `${currentTypeElement.offsetWidth}px`
			}
		}
	}, [currentIndex, types.length, animationState])

	return (
		<div className={`flex flex-wrap items-left break-words space-y-2 md:space-y-0 md:space-x-2 w-full transition-opacity duration-500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
			<div className="py-2 sm:mt-2 sm:mr-2">Build <span className='text-selectiveYellow'>Your Own</span></div>
			<br />
			<div className='flex flex-row' style={{marginLeft: 0}}>
				<div ref={containerRef} className="flex items-center mr-0 p-0 transition-width duration-1000 xs:min-w-[50px] sm:min-w-[90px] md:min-w-[100px]" style={{ width: 'auto', height: 'auto', marginLeft: 0 }}>
					{types.map((type, index) => (
						<div
							key={type.type}
							data-index={index}
							className={`break-words absolute transition-opacity m-0 py-2 duration-5000 ${type.fontClass}  ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`}
							style={{
								fontFamily: type.font,
								transition: 'opacity 0.5s, width 0.5s',
								willChange: 'opacity, width',
							}}
						>
							{type.type}
						</div>
					))}
				</div>
				<div className="py-2 transition-all duration-1000" style={{ marginLeft: '8px' }}>Business</div>
			</div>
		</div>
	)
}

export default AnimatedTypeComponent
